const doubleArrow = (color = '#FFFFFF') => `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="21px" height="20px" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
    <title>double_arrow</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="loadmore-icon" transform="translate(-706.000000, -782.000000)" fill="${color}" fill-rule="nonzero" stroke="${color}">
            <g id="Group" transform="translate(685.000000, 737.000000)">
                <g id="double_arrow" transform="translate(21.000000, 46.000000)">
                    <path d="M19.772,0.689 C19.509,0.426 19.081,0.426 18.818,0.689 L10.434,9.089 L2.034,0.689 C1.771,0.426 1.344,0.426 1.081,0.689 C0.817,0.953 0.817,1.38 1.081,1.643 L9.941,10.504 C10.073,10.636 10.237,10.701 10.418,10.701 C10.583,10.701 10.764,10.636 10.896,10.504 L19.756,1.643 C20.036,1.381 20.036,0.953 19.772,0.689 Z" id="Shape"></path>
                    <path d="M19.772,7.899 C19.509,7.636 19.081,7.636 18.818,7.899 L10.434,16.299 L2.034,7.899 C1.771,7.636 1.344,7.636 1.081,7.899 C0.817,8.163 0.817,8.59 1.081,8.853 L9.941,17.714 C10.073,17.846 10.237,17.911 10.418,17.911 C10.583,17.911 10.764,17.846 10.896,17.714 L19.756,8.853 C20.036,8.591 20.036,8.163 19.772,7.899 Z" id="Shape"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

export default doubleArrow;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/doubleArrow.js